import PropTypes from 'prop-types';
import React from 'react';

const style = {
  margin: '25px 0 25px',
  width: '100%',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '400',
  textAlign: 'center',
};

const Header = ({
  size,
  color,
  fontWeight,
  children,
}) => {
  const showSize = () => {
    switch (size) {
      case '1':
        return <h1 style={{ ...style, fontSize: '56px', fontWeight, color }}>{children}</h1>;
      case '2':
        return <h2 style={{ ...style, fontSize: '34px', fontWeight, color }}>{children}</h2>;
      case '3':
        return <h3 style={{ ...style, fontSize: '26px', fontWeight, color }}>{children}</h3>;
      case '4':
        return <h4 style={{ ...style, fontSize: '22px', fontWeight, color }}>{children}</h4>;
      case '5':
        return <h5 style={{ ...style, fontSize: '18px', fontWeight, color }}>{children}</h5>;
      case '6':
        return <h6 style={{ ...style, fontSize: '16px', fontWeight, color }}>{children}</h6>;
      default:
        return <h4 style={{ ...style, fontSize: '22px', fontWeight, color }}>{children}</h4>;
    }
  };

  return (
    <>{showSize()}</>
  );
};

Header.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  fontWeight: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Header.defaultProps = {
  color: '#004e63',
  size: 'h2',
  fontWeight: '400',
};

export default Header;
